module.exports = __webpack_public_path__ + "static/media/Kayla.9da04c46.png";